import styled from 'styled-components'

import { ContactCard } from '@/components/shared-components/ContactCard'
import { Flexbox } from '@/components/shared-components/Flexbox'

import { ProjectContactsUiQuery } from 'types/api.graphql'

const ContactInfo = styled.div`
  flex-basis: 50%;
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
`

const ContactWrapper = styled.div`
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colour.neutral.border};
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 0.125rem;

  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  & > ${ContactInfo}:nth-child(2) {
    justify-content: flex-end;
  }
`

type ProjectContact =
  ProjectContactsUiQuery['project']['projectContacts'][number]

type Contact = {
  id: ProjectContact['id']
  name?: ProjectContact['name']
  number?: ProjectContact['number']
  type: ProjectContact['type']
  customType?: ProjectContact['customType']
  email?: string
}

type Props = {
  contacts: Contact[]
}

export const ProjectContactsList: React.FC<Props> = ({ contacts }) => {
  return (
    <Flexbox flexDirection="column">
      {contacts.map((contact) => (
        <ContactWrapper key={contact.id}>
          <ContactCard contact={contact} showMobile />
        </ContactWrapper>
      ))}
    </Flexbox>
  )
}
